import ENG from './ENG';
import NOR from './NOR';
import DAN from './DAN';
import SWE from './SWE';
import FIN from './FIN';

const messages = {
  ENG,
  NOR,
  DAN,
  SWE,
  FIN,
};

export default messages;
